import createModalModel, { prop } from './lib/create_modal_model';

export default createModalModel({
  modelName: 'RedactTaskComment',
  properties: {
    itemId: prop(String),
    commentId: prop(String),
  },
});
